import type { GameEvent } from '../shared/types';
import { getState, viewerSeat } from './store';
import {
  renderGame,
  renderTrickSlot,
  flashTrickWinner,
  showBidToast,
  holdFinishedTrick,
  releaseFinishedTrick,
} from './render';

/** How long a finished trick stays on the felt before the board clears. */
const TRICK_HOLD_MS = 400;

let queue: GameEvent[] = [];
let running = false;

function sleep(ms: number): Promise<void> {
  return new Promise(resolve => window.setTimeout(resolve, ms));
}

export function enqueueEvents(events: GameEvent[]): void {
  if (!events.length) {
    renderGame();
    return;
  }
  queue.push(...events);
  if (!running) void pump();
}

async function pump(): Promise<void> {
  running = true;
  try {
    while (queue.length) {
      const ev = queue.shift()!;
      if (ev.type === 'cardPlayed' && ev.playerIndex !== undefined && ev.card) {
        renderTrickSlot(ev.playerIndex, ev.card);
        dropOpponentBack(ev.playerIndex);
      } else if (ev.type === 'trickComplete') {
        flashTrickWinner(ev.winner);
        holdFinishedTrick();
        renderGame();
        await sleep(TRICK_HOLD_MS);
        releaseFinishedTrick();
        renderGame();
      } else if (ev.type === 'bidMade' && ev.playerIndex !== undefined && ev.bid !== undefined) {
        showBidToast(ev.playerIndex, ev.bid);
      }
    }
  } catch (e) {
    // A throw mid-animation must not leave the trick held and the hand
    // locked for good; drop the backlog and paint the live board.
    console.error('animation pump failed', e);
    queue = [];
  } finally {
    releaseFinishedTrick();
    running = false;
    renderGame();
  }
}

function dropOpponentBack(playerIndex: number): void {
  if (playerIndex === viewerSeat) return;
  const map: Record<number, string> = {
    [(viewerSeat + 1) % 4]: 'west-player',
    [(viewerSeat + 2) % 4]: 'north-player',
    [(viewerSeat + 3) % 4]: 'east-player',
  };
  const id = map[playerIndex];
  if (!id) return;
  const backs = document.getElementById(id)?.querySelectorAll('.card-back');
  if (backs && backs.length > 0) backs[backs.length - 1].remove();
}

export function paintNow(): void {
  if (!getState()) return;
  renderGame();
}
